export default __webpack_public_path__ + "static/media/save-icon.60e32a3f.svg";